import React from "react";
import { seoUrl } from "../lib/helpers";
import { buildImageObj } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import ScrollContainer from 'react-indiana-drag-scroll';
import Container from "./container";

import SectionHeader from "./product-section-header";

import * as styles from "../styles/components/product-how-it-works.module.css";

const HowItWorks = (props) => {

  const {
    title,
    subtitle,
    _rawContent,
    image
  } = props;

  return (
    <div className={styles.root} id={subtitle ? seoUrl(subtitle) : undefined}>
      {title && (<SectionHeader title={title} subtitle={subtitle} description={_rawContent} />)}
      <Container>
        {image && image.asset && (
          <ScrollContainer className={styles.image} vertical="false">
            <img
              src={imageUrlFor(buildImageObj(image))
                .auto("format")
                .url()}
              alt={image.alt}
            />
          </ScrollContainer>
        )}
      </Container>
    </div>
  );
}

export default HowItWorks;
